module.exports = __webpack_public_path__ + "img/1496086823.45883659.jpg";